import { ErrorFallback } from './ErrorBoundry.js'

export const RouterErrorBoundary = () => {
  return <ErrorFallback />
}
